import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Empty } from 'antd'

class StaticsTableCutoff extends Component {

    render() {
        const { data = {}, loading, error } = this.props
        const { items = [], overtime, total, total_with_note, overtime_with_note, total_no_note, overtime_no_note } = data || {}

        const getPercent = (value) => {
            if (!Number.isInteger(value * 100)) {
                return (value * 100).toFixed(2) + '%'
            } else {
                return value * 100 + '%'
            }
        }

        return (
            <div className="StaticsTableCutoff">
                {
                    !!error && error.length > 0 &&
                    <label className='text-danger w-100 text-left'>{error}</label>
                }
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className='text-left'>SKU</th>
                            <th>Tổng items cần sản xuất</th>
                            <th>Items cần sản xuất (No note)</th>
                            <th>Items cần sản xuất (Has note)</th>
                            <th>Tổng items quá hạn</th>
                            <th>Quá hạn (No note)</th>
                            <th>Quá hạn (Has note)</th>
                            <th>Tỉ lệ quá hạn (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(items) && items.length > 0 && <tr >
                            <td className='text-left font-weight-bold'>Total</td>
                            <td className='font-weight-bold'>{total || 0}</td>
                            <td className='font-weight-bold'>{total_no_note || 0}</td>
                            <td className='font-weight-bold'>{total_with_note || 0}</td>
                            <td className='font-weight-bold'>{overtime || 0}</td>
                            <td className='font-weight-bold'>{overtime_no_note || 0}</td>
                            <td className='font-weight-bold'>{overtime_with_note || 0}</td>
                            <td></td>
                        </tr>}
                        {
                            Array.isArray(items) && items.length > 0 ? items.map((item, index) =>
                                <tr key={index}>
                                    <td className='SKU text-left'>{item.type}</td>
                                    <td>{item.total || 0}</td>
                                    <td>{item.total_no_note || 0}</td>
                                    <td>{item.total_with_note || 0}</td>
                                    <td>{item.overtime || 0}</td>
                                    <td>{item.overtime_no_note || 0}</td>
                                    <td>{item.overtime_with_note || 0}</td>
                                    <td>{getPercent(item.overtime_rate) || 0}</td>
                                </tr>
                            ) :
                                <tr>
                                    <td colSpan={8}><Empty description='No data' /></td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

StaticsTableCutoff.propTypes = {
    data: PropTypes.any.isRequired,
    loading: PropTypes.any,
    error: PropTypes.string
}

export default StaticsTableCutoff
